class perfilSrv {

	constructor ($resource, SERVICE_URL_CONSTANT, GlobalConfig) {
		var addNotificationsTransactions = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsTransactions', {}, {
			add: {
				method: 'POST',
			},
		})

		// PORTFOLIO SERVICES
		var perfildocente = $resource(SERVICE_URL_CONSTANT.rosario + '/perfil/:router/:teacherId/:year/:idHist/:ticketId', {}, {
			getperfildocente: {
				method: 'GET',
				params: {
					router: 'perfildocente',
				},
			},
			getperfildocenteChart: {
				method: 'GET',
				params: {
					router: 'getperfildocenteChart',
				},
			},
			getperfil_dash: {
				method: 'GET',
				params: {
					router: 'perfil_dash',
				},
			},
			PerfildeInvestigacion: {
				method: 'GET',
				params: {
					router: 'PerfildeInvestigacion',
				},
			},
			PerfildeInvestigacionChart: {
				method: 'GET',
				params: {
					router: 'PerfildeInvestigacionChart',
             
				},
			},
			perfilextention: {
				method: 'GET',
				params: {
					router: 'perfilextention',
				},
			},
			perfilextentionChart: {
				method: 'GET',
				params: {
					router: 'perfilextentionChart',
				},
			},
			perfilFormacion: {
				method: 'GET',
				params: {
					router: 'perfilFormacion',
				},
			},     
			trayectoriaURDetail: {
				method: 'GET',
				params: {
					router: 'trayectoriaURDetail',
				},
			},
			TrayectoriaURGraph: {
				method: 'GET',
				params: {
					router: 'trayectoriaURGraph',
				},
			},
			trayectoriaUR: {
				method: 'GET',
				params: {
					router: 'trayectoriaUR',
				},
			},
			reconocimientoSeincentivos: {
				method: 'GET',
				params: {
					router: 'reconocimientoSeincentivos',
				},
			},
			trayectoriaprevia: {
				method: 'GET',
				params: {
					router: 'trayectoriaprevia',
				},
			},
			ActualizaciondePerfil: {
				method: 'GET',
				params: {
					router: 'actualizaciondePerfil',
				},
			},
			getLogs: {
				method: 'GET',
				params: {
					router: 'listadoLog',
				}, 
			}, 
			getStates: {
				method: 'GET',
				params: {
					router: 'resumenDeLogPerfil',
				}, 
			},
			getDataToUpdate: {
				method: 'GET',
				params: {
					router: 'obtenerDatosActualizacion',
				}, 
			},
			getUpdateForms: {
				method: 'GET',
				params: {
					router: 'updateForms',
				}, 
			},
			getUpdateFormsMaintainer: {
				method: 'GET',
				params: {
					router: 'updateFormsMaintainer',
				}, 
			}, 

		})

		var perfilFormacionFiltro = $resource(SERVICE_URL_CONSTANT.rosario + '/perfil/:router/:teacherId/:typeFormation', {}, {
			perfilFormacionFiltro: {
				method: 'GET',
				params: {
					router: 'perfilFormacionFiltro',
				}, 
			},  
		})

		var perfildocenteByRole = $resource(SERVICE_URL_CONSTANT.rosario + '/perfil/:router/:roleId/:userId', {}, {
			actualizaciondePerfilByUserRole: {
				method: 'GET',
				params: {
					router: 'actualizaciondePerfilByUserRole',
				}, 
			},  
		})

		var role = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:param1', {}, {
			getInfo: {
				method: 'GET',
				params: {
					type : 'perfil',
					route: 'esDocente',
				}, 
			},
			getType: {
				method: 'GET',
				params: {
					type : 'strategic_tracking', 
					route: 'getUserTypeRoles',
				},
			},
		})

		var list = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:param1/:param2/:param3', {}, {
			getDetailPerfilDocente: {
				method: 'GET',
				params: {
					type : 'perfil',
					route: 'perfilDocenteDetails',
				},
			},
			getCountriesAndCities: {
				method: 'GET',
				params: {
					type : 'perfil',
					route: 'getCountryCity',
				},
			},
			getListItems: {
				method: 'GET',
				params: {
					type : 'list',
					route: 'getListItems',
				}, 
			},
			getListItemsByIdListForRole: {
				method: 'GET',
				params: {
					type : 'list',
					route: 'getListItemsByIdListForRole',
				}, 
			},
			getListItemsSubtype: {
				method: 'GET',
				params: {
					type : 'list',
					route: 'getListItemsDepend',
				}, 
			},
			getListDocentes: {
				method: 'GET',
				params: {
					type : 'perfil',
					route: 'listDocentes',
				}, 
			},
			getListStage: {
				method: 'GET',
				params: {
					type : 'perfil',
					route: 'getStageList',
				}, 
			},
			listTypeTrayect: {
				method: 'GET',
				params: {
					type : 'perfil',
					route: 'listTypeTrayect',
				}, 
			},
		})

		var listStage = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:stageId/:typeId/:roleId/:stageCurrentId', {}, {
			getListStage: {
				method: 'GET',
				params: {
					type : 'perfil',
					route: 'getStageList',
				}, 
			},
		})

		var post = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route', {}, {
			getUndAcademicAndRole: {
				method: 'POST',
				params: {
					type : 'activity',
					route: 'getDataRolesList',
				}, 
			},
			saveBiography: {
				method: 'POST',
				params: {
					type : 'perfil',
					route: 'savePerfil_dashBiography',
				}, 
			},
			saveInterestArea: {
				method: 'POST',
				params: {
					type : 'perfil',
					route: 'savePerfil_dashInterest',
				}, 
			},
			saveInvestigationData: {
				method: 'POST',
				params: {
					type : 'perfil',
					route: 'saveActualizacionDatosInvestigacion',
				}, 
			},
			savePersonalData: {
				method: 'POST',
				params: {
					type : 'perfil',
					route: 'saveActualizacionDatosPersonales',
				}, 
			},
			saveExtensionData: {
				method: 'POST',
				params: {
					type : 'perfil',
					route: 'saveActualizacionDatosExtension',
				}, 
			},
			saveFormationData: {
				method: 'POST',
				params: {
					type : 'perfil',
					route: 'saveActualizacionDatosFormacion',
				}, 
			},
			saveTrajectoryData: {
				method: 'POST',
				params: {
					type : 'perfil',
					route: 'saveActualizacionTrayectoriaUR',
				}, 
			},
			savePrevTrajectoryData: {
				method: 'POST',
				params: {
					type : 'perfil',
					route: 'saveActualizacionTrayectoriaPrevia',
				}, 
			},
			saveRecognitionData: {
				method: 'POST',
				params: {
					type : 'perfil',
					route: 'saveUpdateReconocimientoEincentivos',
				}, 
			},
			saveChangeStage: {
				method: 'POST',
				params: {
					type : 'perfil',
					route: 'saveChangeStage',
				}, 
			},
		})
		var getFileSrv = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:requestId/:userId/:logId/:fileName', {}, {
			getFile: {
				method: 'GET',
				params: {
					type : 'perfil',
					route: 'downloadFile',
				}, 
			},
		})
		var getFileBitacoraSrv = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:logId', {}, {
			getFiles: {
				method: 'GET',
				params: {
					type : 'perfil', 
					route: 'getFilesBitacora',
				},
			},
		})
		var getCVDocumentsSrv = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/', {}, {
			getDocs: {
				method: 'POST',
				params: {
					type : 'perfil', 
					route: 'getCVDocuments',
				},
			},
		})
		var getInstitutionsSrv = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/', {}, {
			getInstitutions: {
				method: 'GET',
				params: {
					type : 'perfil', 
					route: 'getInstitutions',
				},
			},
		})
		var getAcademicPeriodsSrv = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/', {}, {
			getPeriods: {
				method: 'GET',
				params: {
					type : 'perfil', 
					route: 'getAcademicPeriods',
				},
			},
		})
		const workflows = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/', {}, {
			setProfileUpdateWorkflow: {
				method: 'POST',
				params: {
					type : 'perfil', 
					route: 'setProfileUpdateWorkflow',
				},
			},
			getFormUsers: {
				method: 'POST',
				params: {
					type : 'perfil', 
					route: 'getFormUsers',
				},
			},
		})
    
		// SERVICES INJECTION
		return {
			addNotificationsTransactions: addNotificationsTransactions,
			perfildocente               : perfildocente,
			post                        : post,
			list                        : list,
			role                        : role,
			perfilFormacionFiltro       : perfilFormacionFiltro,
			perfildocenteByRole         : perfildocenteByRole,
			listStage                   : listStage,
			getFileSrv                  : getFileSrv,
			getFileBitacoraSrv          : getFileBitacoraSrv,
			getCVDocumentsSrv           : getCVDocumentsSrv,
			getInstitutionsSrv          : getInstitutionsSrv,
			getAcademicPeriodsSrv       : getAcademicPeriodsSrv,
			workflows                   : workflows,
		}
	}

}
perfilSrv.$inject = [ '$resource', 'SERVICE_URL_CONSTANT', 'GlobalConfig' ]
export default angular.module('services.perfilSrv', []).service('perfilSrv', perfilSrv).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfilSrv.js